import { ONE_MINUTE_MS } from '@/utils/dateTime';

export const CATALOG_CACHE_TIME = 2 * ONE_MINUTE_MS;
